import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import '../../assets/css/Tab.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons'
import Service1 from '../../assets/Images/service-image/initial.webp';
import Service2 from '../../assets/Images/bg-image/scheduled.webp';
import Service3 from '../../assets/Images/bg-image/housecleaning.webp';
import Service4 from '../../assets/Images/bg-image/lamesa.webp';
import Service5 from '../../assets/Images/bg-image/sandiego.webp';
import Service6 from '../../assets/Images/bg-image/checklist.webp';



function LeftTabsExample() {
    return (
        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
            <Row>
                <Col sm={5}>
                    <Nav variant="pills" className="flex-column">
                        <Nav.Item>
                            <Nav.Link eventKey="first"> <FontAwesomeIcon icon={faCircle} />Initial House Cleaning</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="second"> <FontAwesomeIcon icon={faCircle} />Scheduled Maid Service</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="thired"> <FontAwesomeIcon icon={faCircle} />Move In/Out Cleaning Service</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="fourth"> <FontAwesomeIcon icon={faCircle} />La Mesa House Cleaning</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="fifth"> <FontAwesomeIcon icon={faCircle} />San Diego House Cleaning</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="sixth"> <FontAwesomeIcon icon={faCircle} />Cleaning Services Checklist</Nav.Link>
                        </Nav.Item>
                    </Nav>
                </Col>
                <Col sm={7}>
                    <Tab.Content>
                        <Tab.Pane eventKey="first">
                            <div claassName='tab-content'>
                                <div className='tab-content-view'>
                                    <div className='tab-content-img m-auto'>
                                        <div className='tab-service-title'>
                                            Initial House Cleaning
                                        </div>
                                        <img src={Service1} alt="Initial House Cleaning" />
                                        <div className='tab-content-img-text'>
                                            <h3>Get ready for clean!</h3>
                                            <p>Thanks for considering Green Frog. Here’s a few things to keep in mind about your first time house cleaning with us.</p>
                                            <p>Your initial house cleaning differs from regularly scheduled maid service in several important ways.</p>
                                            <p>It would be virtually impossible for your team to “skip” our standard first-time cleaning routine and try to carry on maintaining your home in a satisfactorily-clean fashion. There’s a big difference between “old dirt” and “new dirt”. If we don’t get rid of the old dirt, no matter how hard we try, simply removing the new dirt isn’t going to make things look sparkling fresh and clean.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="second">
                            <div claassName='tab-content'>
                                <div className='tab-content-view'>
                                    <div className='tab-content-img m-auto'>
                                        <div className='tab-service-title'>
                                            Scheduled Maid Service
                                        </div>
                                        <img src={Service2} alt="Scheduled Maid Service" />
                                        <div className='tab-content-img-text'>
                                            <h3>Why schedule regular maid service?</h3>
                                            <p>Once you’ve had our team out for your initial house cleaning and things are looking clean and tidy you’ll want to keep it that way.</p>
                                            <p>We’ll work hard to keep your home in tip-top shape. We progressively work trough rotational tasks at your request to keep your home clean.</p>
                                            <p>With scheduled maid service we can we match you with the same cleaner every visit so you’ll get to know each other over time. Of course things happen and if for some reason we can’t send the same technician on a specific visit we will contact you to see if you prefer to reschedule or continue with a different technician.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="thired">
                            <div claassName='tab-content'>
                                <div className='tab-content-view'>
                                    <div className='tab-content-img m-auto'>
                                        <div className='tab-service-title'>
                                            Move In/Out Cleaning Service
                                        </div>
                                        <img src={Service3} alt="Scheduled Maid Service" />
                                        <div className='tab-content-img-text'>
                                            <h3>Benefits of Move In Cleaning Services</h3>
                                            <p>Now that you’re out of your old place and partially into your new place, there are a few things you need to do before you unpack. It’s important to clean and disinfect surfaces in your new home before settling in. You want to make sure the kitchen is cleaned as well as the bathroom. A professional cleaning service can have this taken care of before you get the last box in the door making sure that the only thing you have left to do is unpack.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="fourth">
                            <div claassName='tab-content'>
                                <div className='tab-content-view'>
                                    <div className='tab-content-img m-auto'>
                                        <div className='tab-service-title'>
                                            La Mesa House Cleaning
                                        </div>
                                        <img src={Service4} alt="Scheduled Maid Service" />
                                        <div className='tab-content-img-text'>
                                            <h3>Who We Are</h3>
                                            <p>Welcome to Green Frog La Mesa where we serve La Mesa and the surrounding cities. We’ve built a legacy in premier house cleaning industry. Here at Green Frog Cleaning, we give the gift of time so that you are able to focus on the things that truly matter – Instead of cleaning the house all day.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="fifth">
                            <div claassName='tab-content'>
                                <div className='tab-content-view'>
                                    <div className='tab-content-img m-auto'>
                                        <div className='tab-service-title'>
                                            San Diego House Cleaning
                                        </div>
                                        <img src={Service5} alt="Scheduled Maid Service" />
                                        <div className='tab-content-img-text'>
                                            <h3>Who We Are</h3>
                                            <p>Welcome to Green Frog La Mesa where we serve La Mesa and the surrounding cities. We’ve built a legacy in premier house cleaning industry. Here at Green Frog Cleaning, we give the gift of time so that you are able to focus on the things that truly matter – Instead of cleaning the house all day.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="sixth">
                            <div claassName='tab-content'>
                                <div className='tab-content-view'>
                                    <div className='tab-content-img m-auto'>
                                        <div className='tab-service-title'>
                                            Cleaning Services Checklist
                                        </div>
                                        <img src={Service6} alt="Scheduled Maid Service" />
                                        <div className='tab-content-img-text'>
                                            <h3>Who We Are</h3>
                                            <p>Welcome to Green Frog La Mesa where we serve La Mesa and the surrounding cities. We’ve built a legacy in premier house cleaning industry. Here at Green Frog Cleaning, we give the gift of time so that you are able to focus on the things that truly matter – Instead of cleaning the house all day.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Tab.Pane>
                    </Tab.Content>
                </Col>
            </Row>
        </Tab.Container>
    );
}

export default LeftTabsExample;